module.exports = __webpack_public_path__ + "static/media/Report 134 Village Study.45aa3d9c.pdf";